import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store.js';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
     {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      props: true,
    },
    {
      path: '/cameras/:filter',
      name: 'cameras',
      component: () => import('../views/Cameras.vue'),
      props: true,
    },
    {
      path: '/sites/:filter',
      name: 'sites',
      component: () => import('../views/Sites.vue'),
      props: true,
    },

    {
      path: '/customers',
      name: 'customers',
      component: () => import('../views/Customers.vue'),
      props: true,
    },
    {
      path: '/',
      name: 'customers',
      component: () => import('../views/Customers.vue'),
      props: true,
    },
    {
      path: '/videos',
      name: 'videos',
      component: () => import('../views/VideoTable.vue'),
      props: true,
    },
    {
      path: '/images',
      name: 'images',
      component: () => import('../views/Images.vue'),
      props: true,
    },
    {
      path: '/wifi/:filter',
      name: 'wifi',
      component: () => import('../views/Wifi.vue'),
      props: true,
    },
    {
      path: '*',
      name: 'not found',
      component: () => import('../views/404.vue'),
    },

  ],
});


router.beforeResolve(async (to, from, next) => {
  if (!store.getters["auth/current_user"]) {
    await store.dispatch("auth/init_auth");
  }
  const auth_service = store.getters["auth/current_user"];
  if (!(to.name == "login" || to.name == "register") && auth_service == null) {
    next({ name: "login", query: { redirect: to.fullPath } });
  } else next();
});

export default router;
